import { Card, CardBody, H5, Link, P } from "@nel-ui/react";

import { useTrackingContext } from "../../analytics";
import { trackExternalLink } from "../../helpers";
import { IHelpAndSupportProps } from "../../interfaces";
import "./style.css";

const mainClass = "help-and-support";
const HelpAndSupport: React.FC<IHelpAndSupportProps> = (
  props: IHelpAndSupportProps
) => {
  const { heading, helpSupportUrl, helpSupportInfo, helpSupportAdditionsInfo } =
    props;
  const track = useTrackingContext();

  return (
    <Card data-testid={`${mainClass}-container`} className={mainClass}>
      <CardBody>
        <H5 as={"h3"} data-testid={`${mainClass}-heading`}>
          {heading}
        </H5>
        <P
          className={`${mainClass}__sub-heading`}
          data-testid={`${mainClass}-sub-heading`}
        >
          <Link
            href={helpSupportUrl}
            target="_blank"
            data-testid={`${mainClass}-link`}
            onClick={() => {
              trackExternalLink(track, helpSupportInfo);
            }}
          >
            {helpSupportInfo}
          </Link>
          {helpSupportAdditionsInfo}
        </P>
      </CardBody>
    </Card>
  );
};

export default HelpAndSupport;
